import mdtoast from '@dmuy/toast'
import '@dmuy/toast/dist/mdtoast.css'

const DEFAULT_OPTIONS = {
  duration: 4000,
  position: 'top right'
}

function toastWarn(message) {
  mdtoast.warning(message, DEFAULT_OPTIONS)
}

function toastError(error) {
  let message = ''
  if (error.response) {
    // Handle Axios error
    const response = error.response
    message = response.data?.text || response.statusText
  } else {
    // Handle regular JS exception
    message = error.message || error
  }

  mdtoast.error(message, { ...DEFAULT_OPTIONS, duration: 8000 })
}

function toastSuccess(message, options = {}) {
  mdtoast.success(message, { ...DEFAULT_OPTIONS, ...options })
}

export {
  toastWarn,
  toastError,
  toastSuccess
}
